export const addHash = (path: string): string => `#${path}`;

export const addSearchParams = (path: string, params: string): string => `${path}?${params}`;